/* eslint-disable @typescript-eslint/no-explicit-any */
import { getDataValue } from '@juvare/json-data-util';
/**
 * Validates that a given value is unique within a dynamic list, such as a data grid or modal list.
 *
 * @param {WidgetProps<any, any>} props - The widget props used for context and data access.
 * @param {any} value - The value to be validated for uniqueness.
 * @param {string} dataPath - The path to the value within the data structure.
 * @returns {string | undefined} An error message if the value is not unique; otherwise, undefined.
 */
export function validateUniqueInList(props, value, dataPath) {
    var _a, _b, _c, _d;
    if (props.config.type === 'form.dataGrid' || props.config.type === 'form.modalRowList' || props.config.type === 'form.modalPanelList') {
        if (dataPath.startsWith(props.dataPath + '.#')) {
            const { skipIndex, arrayDataPath } = splitDataPath(dataPath, props.dataPath);
            const valueArray = [];
            const dataArray = props.getDataArray();
            for (let i = 0; i < ((_b = (_a = props.childDynamicRows) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); ++i) {
                if (i === skipIndex) {
                    continue;
                }
                valueArray.push(getDataValue(dataArray[i], arrayDataPath));
            }
            if (valueArray.includes(value)) {
                return 'This value is already used';
            }
        }
    }
    else if (props.parentProps) {
        return validateUniqueInList(props.parentProps, value, dataPath);
    }
    else if ((_c = props.rootParams.formParams) === null || _c === void 0 ? void 0 : _c.parentModalWidgetHandler) {
        const handler = (_d = props.rootParams.formParams) === null || _d === void 0 ? void 0 : _d.parentModalWidgetHandler;
        if (handler.props && handler.props.config.type === 'form.modalRowList') {
            if (handler.dynamicRow) {
                // editing existing row
                return validateUniqueInList(handler.props, value, handler.props.dataPath + '.#' + handler.dynamicRow.index + '.' + dataPath);
            }
            else {
                // adding new row
                // note that the dataPath is not valid due to '.#.', this is ok, because we deconstruct it in splitDataPath and handle the '.#.' case
                return validateUniqueInList(handler.props, value, handler.props.dataPath + '.#.' + dataPath);
            }
        }
    }
    return undefined;
}
function splitDataPath(dataPath, dataPathPrefix) {
    const endIndex = dataPath.indexOf('.', dataPathPrefix.length + 2);
    const skipIndexString = dataPath.substring(dataPathPrefix.length + 2, endIndex !== -1 ? endIndex : undefined);
    const arrayDataPath = endIndex !== -1 ? dataPath.substring(endIndex + 1) : '';
    return { skipIndex: skipIndexString !== '' ? parseInt(skipIndexString) : undefined, arrayDataPath };
}
